import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

interface ImagePreviewProps {
  url: string;
  alt?: string;
  size?: number;
}

export function ImagePreview({ url, alt = 'Preview', size = 64 }: ImagePreviewProps) {
  const [valid, setValid] = useState(false);

  useEffect(() => {
    setValid(false);
    if (!url) return;
    const img = new window.Image();
    img.onload = () => setValid(true);
    img.onerror = () => setValid(false);
    img.src = url;
  }, [url]);

  if (!url || !valid) return null;

  return (
    <motion.img
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      src={url}
      alt={alt}
      style={{ width: size, height: size }}
      className="rounded-xl object-cover border border-slate-700/50"
    />
  );
}
